import store from "../redux/store";

const v1 = "api/v1/";
const apiUrl = process.env.REACT_APP_API_BASE_URL;
// const apiUrl = "http://localhost:5001/";

const currentDate = new Date();
const year = currentDate.getFullYear();
const month = String(currentDate.getMonth() + 1).padStart(2, '0');
const day = String(currentDate.getDate()).padStart(2, '0');
const formattedDate = `${year}-${month}-${day}`;
export const getUriWithDurationAndDateFormat = (uri, duration = 'w', date) => {
  if (duration) uri += `&duration=${duration.toLowerCase()}`
  return `${uri}&date=${date || formattedDate}`
}

// Dynamic getter — reads from storage on every call so the user type
// is never stale (fixes the "null" in URL bug).
export const getUser = () => {
  return sessionStorage.getItem("userType") || localStorage.getItem("userType");
};

const getUserUrlPrefix = () => {
  const userType = getUser();
  const urlMapping = {
    'subadmin': 'sub-admin',
    'patient': 'patient',
    'doctor': 'doctor',
    'organization': 'organization'
  };
  return urlMapping[userType] || userType;
};

const timezone = new Intl.DateTimeFormat().resolvedOptions().timeZone;

// ---------------------------------------------------------------
// USER-TYPE DEPENDENT URLs (functions — must be called to resolve)
// ---------------------------------------------------------------
// These are functions instead of constants because the userType is
// not available in storage when the module first loads (before login).
// Call them at the point of use, e.g.: LOGIN() instead of LOGIN.
// ---------------------------------------------------------------

export const LOGIN = () => `${apiUrl}${v1}${getUser()}/login`;
export const REFRESH_TOKEN = () => `${apiUrl}${v1}${getUserUrlPrefix()}/refresh-token`;
export const VERIFY_LOGIN_OTP = () => `${apiUrl}${v1}${getUser()}/verify-login-otp`;
export const RESEND_LOGIN_OTP = () => `${apiUrl}${v1}${getUser()}/resend-login-otp`;
export const LOGIN1 = () => `${apiUrl}${v1}${getUser()}/login`;
export const LOGOUT = () => `${apiUrl}${v1}${getUser()}/logout`;
export const SIGNUP = () => `${apiUrl}${v1}${getUser()}/signup`;
export const FORGOT_PASSWORD = () => `${apiUrl}${v1}${getUser()}/forgotpassword`;
export const DELETE_HEALTH_PARAMS = () => `${apiUrl}${v1}${getUser()}/delete-health-params?timezone=${timezone}`;
export const GET_BLOOD_SUGAR = () => `${apiUrl}${v1}${getUser()}/get-blood-sugar?timezone=${timezone}`;
export const GET_HEALTH_PARAMS = () => `${apiUrl}${v1}${getUser()}/get-health-params?timezone=${timezone}`;
export const GET_BODY_TEMPERATURE = () => `${apiUrl}${v1}${getUser()}/get-body-temperature?timezone=${timezone}`;
export const GET_BLOOD_PRESSURE = () => `${apiUrl}${v1}${getUser()}/get-blood-pressure?timezone=${timezone}`;
export const GET_HEART_RATE = () => `${apiUrl}${v1}${getUser()}/get-heart-rate?timezone=${timezone}`;
export const GET_LIPID_DATA = () => getUriWithDurationAndDateFormat(`${apiUrl}${v1}${getUser()}/get-lipid?timezone=${timezone}`, 'w');
export const GET_RESPIRATORY_RATE = () => `${apiUrl}${v1}${getUser()}/get-respiratory-rate?timezone=${timezone}`;
export const GET_STEPS_DATA = () => `${apiUrl}${v1}${getUser()}/get-steps?timezone=${timezone}`;
export const GET_SLEEP_DATA = () => `${apiUrl}${v1}${getUser()}/get-sleep?timezone=${timezone}`;
export const GET_OXYGEN = () => `${apiUrl}${v1}${getUser()}/get-spo2?timezone=${timezone}`;
export const GET_LATEST_ECG = () => `${apiUrl}${v1}${getUser()}/get-latest-ecg`;
export const ADD_RESPIRATORY_RATE = () => `${apiUrl}${v1}${getUser()}/add-respiratory-rate`;
export const ADD_HEART_RATE = () => `${apiUrl}${v1}${getUser()}/add-heart-rate`;
export const ADD_BLOOD_PRESSURE = () => `${apiUrl}${v1}${getUser()}/add-blood-pressure`;
export const ADD_BLOOD_SUGAR = () => `${apiUrl}${v1}${getUser()}/add-blood-sugar`;
export const ADD_BLOOD_OXYGEN = () => `${apiUrl}${v1}${getUser()}/add-spo2`;
export const ADD_BODY_TEMPERATURE = () => `${apiUrl}${v1}${getUser()}/add-body-temperature`;
export const GET_PATIENT_PROFILE = () => `${apiUrl}${v1}${getUser()}/get-profile`;
export const UPDATE_PATIENT_PROFILE = () => `${apiUrl}${v1}${getUser()}/update-patient`;
export const ADD_LIPID_PROFILE = () => `${apiUrl}${v1}${getUser()}/add-lipid`;
export const ADD_MEDICAL_REPORT = () => `${apiUrl}${v1}${getUser()}/add-medical-report`;
export const DEL_MEDICAL_REPORT = () => `${apiUrl}${v1}${getUser()}/delete-medical-report`;
export const DEL_MULTIPLE_MEDICAL_REPORTS = () => `${apiUrl}${v1}${getUser()}/delete-multiple-medical-reports`;
export const GET_HEALTH_CONDITIONS = () => `${apiUrl}${v1}${getUser()}/get-health-condition`;
export const ADD_HEALTH_CONDITIONS = () => `${apiUrl}${v1}${getUser()}/add-health-condition`;
export const UPDATE_HEALTH_CONDITIONS = () => `${apiUrl}${v1}${getUser()}/update-health-condition`;
export const DEL_HEALTH_CONDITIONS = () => `${apiUrl}${v1}${getUser()}/delete-health-condition`;
export const GET_MEDICATIONS = () => `${apiUrl}${v1}${getUser()}/get-medication`;
export const UPDATE_MEDICATIONS = () => `${apiUrl}${v1}${getUser()}/update-medication`;
export const ADD_MEDICATIONS = () => `${apiUrl}${v1}${getUser()}/add-medication`;
export const DEL_MEDICATIONS = () => `${apiUrl}${v1}${getUser()}/delete-medication`;
export const GET_SURGURIES = () => `${apiUrl}${v1}${getUser()}/get-surgery`;
export const UPDATE_SURGURIES = () => `${apiUrl}${v1}${getUser()}/update-surgery`;
export const ADD_SURGURIES = () => `${apiUrl}${v1}${getUser()}/add-surgery`;
export const DEL_SURGURIES = () => `${apiUrl}${v1}${getUser()}/delete-surgery`;
export const GET_ALLERGY = () => `${apiUrl}${v1}${getUser()}/get-allergy`;
export const UPDATE_ALLERGY = () => `${apiUrl}${v1}${getUser()}/update-allergy`;
export const ADD_ALLERGY = () => `${apiUrl}${v1}${getUser()}/add-allergy`;
export const DEL_ALLERGY = () => `${apiUrl}${v1}${getUser()}/delete-allergy`;
export const GET_VACCINATIONS = () => `${apiUrl}${v1}${getUser()}/get-vaccination`;
export const UPDATE_VACCINATIONS = () => `${apiUrl}${v1}${getUser()}/update-vaccination`;
export const ADD_VACCINATIONS = () => `${apiUrl}${v1}${getUser()}/add-vaccination`;
export const DEL_VACCINATIONS = () => `${apiUrl}${v1}${getUser()}/delete-vaccination`;
export const QRCODE = () => `${apiUrl}${v1}${getUser()}`;
export const FAMILY_MEMBER_REQUEST = () => `${apiUrl}${v1}patient/family-member/request`;
export const FAMILY_MEMBER_REQUEST_RESPOND = (requestId) => `${apiUrl}${v1}patient/family-member/request/${requestId}`;
export const FAMILY_MEMBERS = () => `${apiUrl}${v1}patient/family-members`;
export const FAMILY_MEMBER_INCOMING_REQUESTS = () => `${apiUrl}${v1}patient/family-member/requests/incoming`;
export const FAMILY_MEMBER_SENT_REQUESTS = () => `${apiUrl}${v1}patient/family-member/requests/sent`;
export const FAMILY_MEMBER_REMOVE = (relationId) => `${apiUrl}${v1}patient/family-member/${relationId}`;
export const FAMILY_MEMBER_DATA = (memberId) => `${apiUrl}${v1}patient/family-member/${memberId}/data`;
export const PATIENT_UPLOAD = () => `${apiUrl}${v1}${getUser()}/upload-file`;
export const GET_PATIENT_APPOINTMENT_LIST = () => `${apiUrl}${v1}${getUser()}/appointments`;
export const GET_DOCTOR_LIST = () => `${apiUrl}${v1}${getUser()}/get-doctor`;
export const UPDATE_PASSWORD = () => `${apiUrl}${v1}${getUser()}/update-password?token=`;
export const SLOTS = () => `${apiUrl}${v1}${getUser()}/get-doctor-available-slots?timezone=${timezone}&doctorId=`;
export const CREATE_APPOINTMENT = () => `${apiUrl}${v1}${getUser()}/create-appointment`;
export const VERIFY_TOKEN = () => `${apiUrl}${v1}${getUser()}/verify-password-reset-token?token=`;
export const VERIFY_PAYMENT_PATIENT = () => `${apiUrl}${v1}${getUser()}/verify-payment`;
export const BILLING_INVOICE = () => `${apiUrl}${v1}${getUser()}/get-invoices`;
export const BILLING_INVOICE_DETAIL = () => `${apiUrl}${v1}${getUser()}/get-invoice`;
export const GET_MEDICAL_REPORT = () => `${apiUrl}${v1}${getUser()}/get-medical-report`;

// ---------------------------------------------------------------
// STATIC URLs (no user-type dependency — evaluated once is fine)
// ---------------------------------------------------------------
export const DOCTOR_LOGIN = `${apiUrl}${v1}doctor/sign-in`;
export const VERIFY_DOCTOR_LOGIN_OTP = `${apiUrl}${v1}doctor/verify-login-otp`;
export const RESEND_DOCTOR_LOGIN_OTP = `${apiUrl}${v1}doctor/resend-login-otp`;
export const ORGANIZATION_LOGIN = `${apiUrl}${v1}organization/sign-in`;
export const VERIFY_ORGANIZATION_LOGIN_OTP = `${apiUrl}${v1}organization/verify-login-otp`;
export const RESEND_ORGANIZATION_LOGIN_OTP = `${apiUrl}${v1}organization/resend-login-otp`;
export const QRPATIENTINFO = `${apiUrl}${v1}public/patient-info?`;
export const BILLING_INVOICE_FOR_DOCTOR = `${apiUrl}${v1}doctor/get-invoices`;
export const GET_APPOINTMENT_FOR_DOCTOR = `${apiUrl}${v1}doctor/appointments`;
export const GET_PATIENT_DETAILS_FOR_DOCTOR = `${apiUrl}${v1}doctor/get-patient-details`;
export const GET_DOCTOR_LIPID_DATA = getUriWithDurationAndDateFormat(`${apiUrl}${v1}doctor/get-patient-lipid?timezone=${timezone}`, 'y');
export const GET_DOCTOR_BLOOD_SUGAR = `${apiUrl}${v1}doctor/get-patient-blood-sugar?timezone=${timezone}`;
export const GET_DOCTOR_HEALTH_PARAMS = `${apiUrl}${v1}doctor/get-patient-health-params?timezone=${timezone}`;
export const GET_DOCTOR_BODY_TEMPERATURE = `${apiUrl}${v1}doctor/get-patient-body-temperature?timezone=${timezone}`;
export const GET_DOCTOR_BLOOD_PRESSURE = `${apiUrl}${v1}doctor/get-patient-blood-pressure?timezone=${timezone}`;
export const GET_DOCTOR_HEART_RATE = `${apiUrl}${v1}doctor/get-patient-heart-rate?timezone=${timezone}`;
export const GET_DOCTOR_RESPIRATORY_RATE = `${apiUrl}${v1}doctor/get-patient-respiratory-rate?timezone=${timezone}`;
export const GET_DOCTOR_OXYGEN = `${apiUrl}${v1}doctor/get-patient-spo2?timezone=${timezone}`;
export const GET_PATIENT_PREVIOUS_APPOINTMENTS_FOR_DOCTOR = `${apiUrl}${v1}doctor/get-patient-previous-appointment?timezone=${timezone}&duration=y`;
export const DOCTOR_LOGOUT = `${apiUrl}${v1}doctor/logout`;
export const DOCTOR_UPLOAD = `${apiUrl}${v1}doctor/upload-file`;
export const GET_CURRENCY = `${apiUrl}${v1}public/get-currencies`;
export const GET_DOCTOR_AVAILABLE_TIME = `${apiUrl}${v1}doctor/available-time?timezone=${timezone}`;
export const DOCTOR_ADD_SLOT = `${apiUrl}${v1}doctor/add-slots`;
export const GET_SLOT_BY_DOCTOR = `${apiUrl}${v1}doctor/slots?timezone=${timezone}`;
export const DELETE_SLOT_BY_DOCTOR = `${apiUrl}${v1}doctor/delete-slot?`;
export const SEND_MEDICATION_BY_DOCTOR = `${apiUrl}${v1}doctor/add-eprescription`;
export const COMPLETE_APPOINTMENT_BY_DOCTOR = `${apiUrl}${v1}doctor/complete-appointment`;
export const CANCEL_APPOINTMENT_BY_PATIENT = `${apiUrl}${v1}patient/cancel-appointment`;
export const CONFIRM_APPOINTMENT_BY_DOCTOR = `${apiUrl}${v1}doctor/confirm-appointment`;
export const PATIENT_CHECKOUT = `${apiUrl}${v1}patient/appointment/checkout`;
export const GET_PROFILE_BY_DOCTOR = `${apiUrl}${v1}doctor/get-profile`;
export const UPDATE_PROFILE_BY_DOCTOR = `${apiUrl}${v1}doctor/update-profile`;
export const GET_PATIENT_MEDICAL_REPORT = `${apiUrl}${v1}doctor/get-patient-medical-reports?timezone=${timezone}&duration=y`;
export const GET_MEDICAL_DETAILS_BY_PATIENT = `${apiUrl}${v1}patient/get-medical-detailes`;
export const GET_MEDICAL_DETAILS_BY_DOCTOR = `${apiUrl}${v1}doctor/get-patient-medical-detailes?duration=y&timezone=${timezone}`;
export const GET_PATIENT_PRESCRIPTION_BY_DOCTOR = `${apiUrl}${v1}doctor/get-patient-prescriptions?timezone=${timezone}&duration=y`;
export const GET_PATIENT_EPRESCRIPTION = `${apiUrl}${v1}patient/get-prescriptions`;
export const ORGANIZATION_SIGNUP = `${apiUrl}${v1}organization/sign-up`;
export const VALIDATE_ORGANIZATION_SIGNUP_STEP = `${apiUrl}${v1}organization/validate-signup-step`;
export const ORGANIZATION_GET_APPOINTMENTLIST = `${apiUrl}${v1}organization/appointments`;
export const GET_ORGANIZATION_HEALTH_PARAMS = `${apiUrl}${v1}organization/get-patient-health-params?timezone=${timezone}`;
export const REMOVE_ORGANIZATION_PATIENT = `${apiUrl}${v1}organization/remove-patient-organization`;
export const GET_PATIENT_DETAILS_FOR_ORGANIZATION = `${apiUrl}${v1}organization/get-patient-details`;
export const GET_DOCTOR_DETAILS_FOR_ORGANIZATION = `${apiUrl}${v1}organization/get-doctor-details`;
export const GET_SUBADMIN_DETAILS_FOR_ORGANIZATION = `${apiUrl}${v1}organization/get-subadmin-details`;
export const GET_ORGANIZATION_LIPID_PROFILE = `${apiUrl}${v1}organization/get-patient-lipid?timezone=${timezone}`;
export const GET_MEDICAL_DETAILS_FOR_ORGANIZATION = `${apiUrl}${v1}organization/get-patient-medical-detailes?timezone=${timezone}&duration=y`;
export const GET_MEDICAL_REPORTS_FOR_ORGANIZATION = `${apiUrl}${v1}organization/get-patient-medical-reports?timezone=${timezone}&duration=y`;
export const GET_EPRESCIPTION_FOR_ORGANIZATION = `${apiUrl}${v1}organization/get-patient-prescriptions?timezone=${timezone}&duration=y`;
export const GET_PATIENT_PREVIOUS_APPOINTMENTS_FOR_ORGANIZATION = `${apiUrl}${v1}organization/get-patient-previous-appointment?timezone=${timezone}&duration=y`;
export const GET_PATIENT_BLOOD_SUGAR_ORGANIZATION = `${apiUrl}${v1}organization/get-patient-blood-sugar?timezone=${timezone}`;
export const GET_PATIENT_OXYGEN_ORGANIZATION = `${apiUrl}${v1}organization/get-patient-spo2?timezone=${timezone}`;
export const GET_PATIENT_BLOOD_PRESSURE_ORGANIZATION = `${apiUrl}${v1}organization/get-patient-blood-pressure?timezone=${timezone}`;
export const GET_PATIENT_BODY_TEMPERATURE_ORGANIZATION = `${apiUrl}${v1}organization/get-patient-body-temperature?timezone=${timezone}`;
export const GET_PATIENT_HEART_RATE_ORGANIZATION = `${apiUrl}${v1}organization/get-patient-heart-rate?timezone=${timezone}`;
export const ORGANIZATION_REMOVE_PATIENT = `${apiUrl}${v1}organization/remove-patient-organization`;
export const ORGANIZATION_DOCTOR_UPDATE_STATUS = `${apiUrl}${v1}organization/update-doctor-status`;
export const ORGANIZATION_SUBADMIN_UPDATE_STATUS = `${apiUrl}${v1}organization/update-subadmin-status`;

export const GET_PATIENT_RESPIRATORY_RATE_ORGANIZATION = `${apiUrl}${v1}organization/get-patient-respiratory-rate?timezone=${timezone}`;
export const GET_PATIENT_LIST = `${apiUrl}${v1}organization/get-patients`;
export const GET_DOCTOR_LIST_FOR_ORGANIZATION = `${apiUrl}${v1}organization/get-doctors`;
export const ADD_DOCTOR = `${apiUrl}${v1}organization/add-doctor`;
export const ORGANIZATION_SUBSCRIPTION_API = `${apiUrl}${v1}organization/create-subscription`;
export const ADD_SUBADMIN = `${apiUrl}${v1}organization/add-subadmin`;
export const GET_ORGANIZATION_PROFILE = `${apiUrl}${v1}organization/get-profile`;
export const GET_PLANS = `${apiUrl}${v1}public/get-plans`;
export const UPDATE_PROFILE_BY_ORGANIZATION = `${apiUrl}${v1}organization/update-profile`;
export const GET_SUBADMIN_LIST = `${apiUrl}${v1}organization/get-subadmin`;
export const GET_INVOICES_BY_ORGANIZATION = `${apiUrl}${v1}organization/get-invoices`;
export const ADD_PATIENT_BY_FORM = `${apiUrl}${v1}organization/add-new-patient`;
export const ADD_PATIENT_BY_ID = `${apiUrl}${v1}organization/update-patient-organizationId`;
export const ORGANIZATION_LOGOUT = `${apiUrl}${v1}organization/logout`;
export const ORGANIZATION_GET_SUBCRIPTION = `${apiUrl}${v1}organization/get-subscription`;
export const VERIFY_PAYMENT_ORGANIZATION = `${apiUrl}${v1}organization/verify-payment`;
export const ORGANIZATION_UPLOAD = `${apiUrl}${v1}organization/upload-file`
export const SUBADMIN_LOGIN = `${apiUrl}${v1}sub-admin/sign-in`;
export const VERIFY_SUBADMIN_LOGIN_OTP = `${apiUrl}${v1}sub-admin/verify-login-otp`;
export const RESEND_SUBADMIN_LOGIN_OTP = `${apiUrl}${v1}sub-admin/resend-login-otp`;
export const GET_PROFILE_BY_SUBADMIN = `${apiUrl}${v1}sub-admin/get-profile`;
export const UPDATE_PROFILE_BY_SUBADMIN = `${apiUrl}${v1}sub-admin/update-profile`;
export const GET_OPD_APPOINTMENTLIST_BY_SUBADMIN = `${apiUrl}${v1}sub-admin/appointments`;
export const GET_INVOICES_BY_SUBADMIN = `${apiUrl}${v1}sub-admin/get-invoices`;
export const SUBADMIN_LOGOUT = `${apiUrl}${v1}sub-admin/logout`;
export const GET_PATIENT_DETAILS_FOR_SUBADMIN = `${apiUrl}${v1}sub-admin/get-patient-details`;
export const GET_SUBADMIN_HEALTH_PARAMS = `${apiUrl}${v1}sub-admin/get-patient-health-params?timezone=${timezone}`;
export const GET_SUBADMIN_LIPID_PROFILE = `${apiUrl}${v1}sub-admin/get-patient-lipid?timezone=${timezone}`;
export const GET_PATIENT_BLOOD_SUGAR_SUBADMIN = `${apiUrl}${v1}sub-admin/get-patient-blood-sugar?timezone=${timezone}`;
export const GET_PATIENT_OXYGEN_SUBADMIN = `${apiUrl}${v1}sub-admin/get-patient-spo2?timezone=${timezone}`;
export const GET_PATIENT_BLOOD_PRESSURE_SUBADMIN = `${apiUrl}${v1}sub-admin/get-patient-blood-pressure?timezone=${timezone}`;
export const GET_PATIENT_BODY_TEMPERATURE_SUBADMIN = `${apiUrl}${v1}sub-admin/get-patient-body-temperature?timezone=${timezone}`;
export const GET_PATIENT_HEART_RATE_SUBADMIN = `${apiUrl}${v1}sub-admin/get-patient-heart-rate?timezone=${timezone}`;
export const GET_PATIENT_RESPIRATORY_RATE_SUBADMIN = `${apiUrl}${v1}sub-admin/get-patient-respiratory-rate?timezone=${timezone}`;
export const GET_MEDICAL_DETAILS_FOR_SUBADMIN = `${apiUrl}${v1}sub-admin/get-patient-medical-detailes?timezone=${timezone}&duration=y`;
export const GET_MEDICAL_REPORTS_FOR_SUBADMIN = `${apiUrl}${v1}sub-admin/get-patient-medical-reports?timezone=${timezone}&duration=y`;
export const GET_PATIENT_PREVIOUS_APPOINTMENTS_FOR_SUBADMIN = `${apiUrl}${v1}sub-admin/get-patient-previous-appointment?timezone=${timezone}&duration=y`;
export const GET_PATIENT_LIST_BY_SUBADMIN = `${apiUrl}${v1}sub-admin/get-patients`;
export const GET_DOCTOR_LIST_FOR_SUBADMIN = `${apiUrl}${v1}sub-admin/get-doctors`;
export const GET_EPRESCRIPTION_FOR_SUBADMIN = `${apiUrl}${v1}sub-admin/get-patient-prescriptions?timezone=${timezone}&duration=y`;
export const SLOTS_BY_SUBADMIN = `${apiUrl}${v1}sub-admin/get-doctor-available-slots?timezone=${timezone}&doctorId=`;
export const CREATE_APPOINTMENT_BY_SUBADMIN = `${apiUrl}${v1}sub-admin/create-appointment`;
export const GET_ROOMS = `${apiUrl}${v1}sub-admin/get-rooms`;
export const ADD_ROOM = `${apiUrl}${v1}sub-admin/add-room`;
export const SUBADMIN_UPLOAD = `${apiUrl}${v1}sub-admin/upload-file`;
export const UPDATE_ROOM = `${apiUrl}${v1}sub-admin/update-room`;
export const ADD_PATIENT_BY_SUBADMIN = `${apiUrl}${v1}sub-admin/add-new-patient`;
export const ADMIT_PATIENT = `${apiUrl}${v1}sub-admin/admit-patient`;
export const ADD_PATIENT_SERVICE = `${apiUrl}${v1}sub-admin/add-admit-patient-service`;
export const GET_ADMITTED_PATIENT = `${apiUrl}${v1}sub-admin/get-admitted-patients?`;
export const VERIFY_PAYMENT_SUBADMIN = `${apiUrl}${v1}sub-admin/verify-payment`;
export const GET_ADMITTED_PATIENT_SERVICE = `${apiUrl}${v1}sub-admin/get-admitted-patient-services?admitPatientId=`;
export const REQUEST_DELETE_PATIENT = `${apiUrl}${v1}patient/request-delete`;
export const VERIFY_DELETE_PATIENT = `${apiUrl}${v1}patient/verify-delete-account`;
export const ANALYZE_REPORT =
  `${apiUrl}${v1}patient/analyze-report`;

export const GET_SCANNED_REPORTS =
  `${apiUrl}${v1}patient/get-scanned-reports`;

export const GET_RECOMMENDATIONS =
  `${apiUrl}${v1}patient/get-recommendations`;

  export const GET_ABNORMAL_REPORTS = `${apiUrl}${v1}patient/get-abnormal-reports`;
  export const GET_BLOOD_COUGH_IMAGE = `${apiUrl}${v1}patient/last-blood-cough-ecg`;
  export const GET_MEDICINE_LIST_FOR_DOCTOR = `${apiUrl}${v1}doctor/search-medication`;
  export const GET_ABNORMAL_REPORTS_BY_DOCTOR = `${apiUrl}${v1}doctor/get-abnormal-reports`;
  export const GET_ABNORMAL_REPORTS_BY_SUBADMIN = `${apiUrl}${v1}sub-admin/get-patient-abnormal-reports`;
  export const GET_ABNORMAL_REPORTS_BY_ORG = `${apiUrl}${v1}organization/get-patient-abnormal-reports`;
  export const GET_DOCTOR_STEPS = `${apiUrl}${v1}doctor/get-patient-steps?timezone=${timezone}`;
  export const GET_PATIENT_STEPS_BY_DOCTOR = `${apiUrl}${v1}doctor/get-patient-sleep?timezone=${timezone}`;
export const GET_ALL_ECG_BY_DATE = `${apiUrl}${v1}patient/get-all-ecg`;
export const GET_DOCTOR_PATIENT_ECG_BY_DATE = `${apiUrl}${v1}doctor/get-patient-ecg`;
export const GET_DOCTOR_PATIENT_LAST_ECG = `${apiUrl}${v1}doctor/get-patient-last-ecg`;

// Shop: read-only list of the patient's Shopify orders
export const SHOP_ORDERS = `${apiUrl}${v1}patient/shop/orders`;
export const SHOP_ORDER_RETURN = `${apiUrl}${v1}patient/shop/orders/return`;
export const SHOP_RETURNABLE_ITEMS = `${apiUrl}${v1}patient/shop/orders/returnable`;
